import {Injectable} from '@angular/core';

import {
    EntityInfoResolver,
    SummaryDetailsResolverService
} from '../../common/services/summary-details-resolver.service';
import {MetadataService} from '../../metadata/metadata.service';

import {AlarmsActionsService} from "./alarms-actions.service";
import {IPDisplayPipe} from 'ac-infra';
import * as _ from "lodash";


@Injectable({providedIn: 'root'})
export class AlarmsEntityInfoService implements EntityInfoResolver {

    entitiesValuesMap: any;

    alarmStatusType: any;
    ituAlarmProbableCause: any;
    ituAlarmType: any;
    journalActivityType: any;
    AlarmOIDTypeByCategories: any;

    ALARMS_TYPE_PREFIX_NAME = {
        sem: null,
        cloudBond: 'CB',
        ipphones: 'IPP',
        arm: 'ARM',
        ems: 'Mgmt',
        board: 'Devices',
        smartap: 'Voice App',
        voiceAI: 'Voice App',
        vipEndpoints: 'VIP IPP',
        genericApplication: 'Generic App',
        stackManager: 'Stack Manager',
        zoomManager: 'UCaaS Connect',
        livehub: 'LiveHub',
        voca: 'VOCA CIC'
    };

    constructor(
        private summaryDetailsResolverService: SummaryDetailsResolverService,
        private alarmsActionsService: AlarmsActionsService,
        private ipDisplayPipe: IPDisplayPipe) {

        this.alarmStatusType = MetadataService.getType('AlarmStatusType');
        this.ituAlarmProbableCause = MetadataService.getType('ItuAlarmProbableCause');
        this.ituAlarmType = MetadataService.getType('ItuAlarmType');
        this.journalActivityType = MetadataService.getType('JournalActivityType');
        this.AlarmOIDTypeByCategories = MetadataService.getType('AlarmOIDTypeByCategories');

        this.entitiesValuesMap = {
            name: {
                title: 'Name',
                icon: this.resolveNameIcon,
                resolver: this.resolveAlarmName,
                titleResolver: (field, value, entity) => entity.forwardType ? `Rule ${field}` : field
            },
            alarmSeverity: {title: 'Severity', template: 'titlecase', icon: 'status', iconMapper: this.alarmsActionsService.severityMap},
            alarmReceivedTime: {title: 'Received Date and Time', template: 'time'},
            alarmDateAndTime: {title: 'Occurred Date and Time', template: 'time'},
            alarmSource: {title: 'Source'},
            alarmSourceDescription: {title: 'Source Description'},
            alarmUniqId: {title: 'Unique ID'},
            alarmCategory: {
                title: 'Alarm Category',
                resolver: (field, value) => this.resolveViewNameByList(value, this.ituAlarmType)
            },
            alarmProbCause: {
                title: 'Probable Cause',
                resolver: (field, value) => this.resolveViewNameByList(value, this.ituAlarmProbableCause)
            },
            alarmTextualDescription: {title: 'Description'},
            alarmAddInfo1: {title: 'Additional Info 1'},
            alarmAddInfo2: {title: 'Additional Info 2'},
            alarmAddInfo3: {title: 'Additional Info 3'},

            unitName: {title: 'Entity Name'},
            alarmRemoteHost: {title: 'IP Address', resolver: (field, value) => this.ipDisplayPipe.transform(value)},
            tenantId: {
                title: 'Tenant',
                resolver: 'ws.service.to.name',
                entityType: 'tenants',
                nullValue: 'System'
            },
            regionId: {
                title: 'Region',
                resolver: 'ws.service.to.name',
                entityType: 'regions',
                nullValue: 'System'
            },
            siteId: {
                title: 'Site',
                resolver: 'ws.service.to.name',
                entityType: 'sites'
            },
            channelId: {
                title: 'Channel',
                resolver: 'ws.service.to.name',
                entityType: 'channels'
            },
            lcCustomerId: {
                title: 'Customer',
                resolver: 'ws.service.to.name',
                entityType: 'lcCustomers'
            },
            serviceId: {
                title: 'Service',
                resolver: 'ws.service.to.name',
                entityType: 'services'
            },
            'attachedEntities.Service': {
                title: 'Service',
                resolver: 'ws.service.to.name',
                entityType: 'services'
            },
            'attachedEntities.Customer': {
                title: 'Customer',
                resolver: 'ws.service.to.name',
                entityType: 'lcCustomers'
            },
            'attachedEntities.Device': {
                title: 'Device',
                resolver: 'ws.service.to.name',
                entityType: 'devices'
            },
            'attachedEntities.Channel': {
                title: 'Channel',
                resolver: 'ws.service.to.name',
                entityType: 'channels'
            },
            alarmOID: {title: 'Trap OID'},
            alarmSystemUpTime: {title: 'System Up Time'},
            alarmRemotePort: {title: 'Trap Remote Port'},
            alarmSNMPCommunity: {title: 'Trap Community'},
            alarmProtocol: {title: 'Trap SNMP Version'},


            alarmStatus: {
                title: 'Status',
                resolver: (field, value) => this.resolveViewNameByList(value, this.alarmStatusType)
            },
            alarmStatusLastUpdateTime: {title: 'Last Action Time', template: 'time'},


            constantSeverity: {title: 'Severity', icon: () => 'fa-circle status-journal', template: 'titlecase'},
            createDateTime: {title: 'Date and Time', template: 'time'},
            source: {title: 'Source'},
            id: {title: 'Alarm ID'},
            clearAlarmId: {title: 'Clear Alarm ID'},
            description: {title: 'Description'},

            'region.name': {title: 'Region'},
            'tenant.name': {title: 'Tenant'},
            'entity.ipAddress': {title: 'Entity IP Address', resolver: (field, value) => this.ipDisplayPipe.transform(value)},
            operator: {title: 'Operator'},
            alarmOperator: {title: 'Operator'},
            operatorIpAddress: {title: 'Operator IP Address'},

            ruleEnabled: {title: 'Active', icon: 'boolean', resolver: 'boolean', template: 'empty'},
            ruleDestType: {title: 'Destination Type'},
            ruleDest: {title: 'Destination', resolver: (field, value) => this.ipDisplayPipe.transform(value)},
            'destRest.path': {title: 'Path'},

            alarmOriginFilter: {title: 'Alarm Origin', resolver: 'array'},
            eventOriginFilter: {title: 'Event Origin', resolver: 'array'},
            alarmSeverityFilter: {title: 'Severities', resolver: 'array'},
            alarmNamesFilter: {title: 'Alarm Names', resolver: this.resolverAlarmFilter},
            alarmTypesFilter: {title: 'Alarm Types', resolver: this.resolverAlarmFilter},
            alarmSourceFilter: {title: 'Source', resolver: 'array'}
        };

    }

    prepareEntityObject = (activeFields: string[], entityInfo: any) => {
        const afterResolved = (resolvedFields: any[]) => resolvedFields.filter((field) => !!field.value);

        return this.summaryDetailsResolverService.resolveFields(activeFields, entityInfo, this.entitiesValuesMap, afterResolved);
    };

    resolveNameIcon = (field, value, entity) => {
        if (entity.constantSeverity !== 'JOURNAL' && !entity.forwardType) {
            return entity.isEvent ? 'fa-flag' : 'fa-bell';
        }
        return;
    };

    resolveViewNameByList = (key, list) => {
        const itemObj = list[key];

        return itemObj ? itemObj.viewName : 'Unknown';
    };

    resolveAlarmName = (field: string, value) => {

        const activityType = this.journalActivityType[value];

        return activityType ? activityType.viewName : value;
    };


    resolverAlarmFilter = (field, value) => {
        if (!Array.isArray(value)) {
            return;
        }

        if (value.length > 1) {
            return value.length + ' Selected';
        } else {
            switch (field) {
                case 'alarmNamesFilter':
                    return this.getAlarmName(value[0]);
                case 'alarmTypesFilter':
                    return this.getAlarmType(value[0]);
            }
        }

    };

    // Helpers
    getAlarmName = (name) => {
        const nameObject = this.AlarmOIDTypeByCategories[name];
        const prefix = this.ALARMS_TYPE_PREFIX_NAME[nameObject.type] ? this.ALARMS_TYPE_PREFIX_NAME[nameObject.type] + ': ' : '';

        return nameObject ? prefix + nameObject.viewName : name;
    };

    getAlarmType = (type) => {
        const typeObject = this.ituAlarmType[type];

        return typeObject ? typeObject.viewName : type;
    };

    prepareAlarmNamesList = () => {
        const alarmNames = [];
        const AlarmOIDTypeByCategoriesList = MetadataService.getType('AlarmOIDTypeByCategories');
        _.forOwn(AlarmOIDTypeByCategoriesList, (item) => {
            alarmNames.push({value: item.name, text: this.generateAlarmsNameWithTypePrefix(item)});
        });

        return alarmNames;
    }

    private generateAlarmsNameWithTypePrefix = (item) => this.ALARMS_TYPE_PREFIX_NAME[item.type] !== null ? this.ALARMS_TYPE_PREFIX_NAME[item.type] + ': ' + item.viewName : item.viewName;

}
